module.exports = __webpack_public_path__ + "media/images/NewBMP-4feedd98fc67850431da53cd09381615.png";